import { Link, useLocation } from "react-router-dom";

const NotFound = () => {
  const location = useLocation();
  return (
    <section className="mx-auto mt-20 max-w-lg px-4 text-center">
      <p className="text-sm font-semibold uppercase tracking-[0.8px] text-ink-3">404</p>
      <h1 className="mt-2 font-serif text-[28px] leading-[34px] font-semibold">This page doesn't exist</h1>
      <p className="mt-2 text-sm text-ink-2 break-all">
        Nothing lives at <code className="rounded bg-secondary px-1">{location.pathname}</code>. Use ⌘K to find a page.
      </p>
      <Link to="/admin/today" className="mt-6 inline-block font-semibold text-blue-ink underline-offset-4 hover:underline">
        Go to Today
      </Link>
    </section>
  );
};

export default NotFound;
